<template>
    <div class="context" v-loading="show_view_loading" :element-loading-text="loading_text"
         element-loading-spinner="el-icon-warning" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="header">
            <div class="search">
                <el-page-header @back="back" :content="viewTitle">
                </el-page-header>
            </div>
        </div>
        <div class="main_box">
            <div class="form" v-if="patientForm">
                <el-form :model="patientForm" size="small" class="not_bottom_form" label-width="150px">
                    <div class="msg_title">
                        <span>基本信息</span>
                        <span style="font-size: 12px;color: #E6A23C;"
                              v-if="patientForm_transfer"
                        >（转化前填报信息）</span>
                    </div>
                    <el-form-item label="患者姓名">
                        <span>{{ patientForm.patient_name }}</span>
                    </el-form-item>
                    <el-form-item label="性别">
                        <span v-if="patientForm.sex == 1">男</span>
                        <span v-else>女</span>
                    </el-form-item>
                    <el-form-item label="手机号">
                        <span>{{ patientForm.phone }}</span>
                    </el-form-item>
                    <el-form-item label="就诊医院">
                        <span>{{ patientForm.hospital }}</span>
                    </el-form-item>
                    <el-form-item label="就诊城市">
                        <span>{{ patientForm.province }}/{{ patientForm.city }}</span>
                    </el-form-item>
                    <el-form-item label="就诊医生">
                        <span>{{ patientForm.doctor_name }}</span>
                    </el-form-item>
                    <el-form-item label="就诊科室">
                        <span>{{ patientForm.department }}</span>
                    </el-form-item>
                    <el-form-item label="上报日期">
                        <span>{{ patientForm.submit_date }}</span>
                    </el-form-item>
                    <el-form-item label="癌种">
                        <span>{{ patientForm.tumour }}</span>

                    </el-form-item>
                    <el-form-item label="分期（选填）">
                        <span>{{ patientForm.stage }}</span>
                    </el-form-item>
                    <el-form-item label="治疗线数">
                        <span>{{ patientForm.line_number }}</span>
                    </el-form-item>
                    <el-form-item label="治疗方案">
                        <span>{{ patientForm.schedule }}</span>
                    </el-form-item>
                    <div class="msg_title">用药信息</div>
                    <el-form-item label="使用药物">
                        <span>{{ showDrugName(patientForm.drug_code) }}</span>
                    </el-form-item>
                    <el-form-item label="购药记录">
                    </el-form-item>
                    <div>
                        <el-table :data="patientForm.medications" stripe>
                            <el-table-column label="周期" prop="medication_cycle_web" width="60"></el-table-column>
                            <el-table-column label="日期" prop="cycle_date" show-overflow-tooltip></el-table-column>
                            <el-table-column label="支数" prop="medication_count" width="60"></el-table-column>
                            <el-table-column label="类别" prop="medication_type"></el-table-column>
                        </el-table>
                    </div>
                    <el-form-item label="是否脱落">
                        <span v-if="patientForm.is_lose == 1">否</span>
                        <span v-else>是</span>
                    </el-form-item>
                    <el-form-item label="脱落原因" v-if="patientForm.is_lose == 2">
                        <span>{{ patientForm.lose_reason1 }}</span>
                    </el-form-item>
                </el-form>
            </div>
            <div class="form form_right">
                <div class="msg_title has_btn_title" v-if="patientForm">
                    <span>
                        {{ patientForm.patient_name }}，{{ patientForm.phone }}
                        <span class="phone_verify_result">{{patientForm.phone_false == 1 ? '(低风险)' : patientForm.phone_false == 2 ? '(高风险)' :''}}</span>
                    </span>
                    <span class="btn" @click="copyPhone()">复制</span>

                    <div class="tabs" ref="tabList" @mousewheel="mousewheel">
                        <div
                                v-for="(item, index) in allTaskData"
                                :key="item.task_id"
                                class="tab_"
                                :class="activeTaskId == item.task_id ? 'active_tab' : ''"
                                @click="activeTab(item)"
                        >
                            {{allTaskData.length - index}}
                            <span>{{item | statusTitleFilter(self_)}}</span>
                        </div>
                    </div>
                </div>
                <el-form :model="taskForm"
                         ref="drug_form"
                         class="el_form_box"
                         size="normal"
                         label-width="200px"
                         :disabled="disabled"
                         :rules="rules">
                    <el-form-item label="医院是否正确" prop="is_hospital_correct">
                        <el-radio-group v-model="taskForm.is_hospital_correct">
                            <el-radio :label="2">是</el-radio>
                            <el-radio :label="1">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="转诊后，购药支数是否正确" prop="is_medication_count_correct">
                        <el-radio-group v-model="taskForm.is_medication_count_correct">
                            <el-radio :label="2">是</el-radio>
                            <el-radio :label="1">否</el-radio>
                        </el-radio-group>
                        <span style="font-size: 12px;padding-left: 20px;color: #C0C4CC"
                        >（“填报购药支数”与“发票购药支数”）</span>
                    </el-form-item>
                    <el-form-item label="转化前发票" v-if="show_image_url_old">
                        <div class="img_box">
                            <el-image class="show_img"
                                      fit="cover"
                                      :src="show_image_url_old"
                                      :preview-src-list="image_list_old">
                            </el-image>
                            <i v-show="image_list_old.length > 1"
                               @click="changeShowImg('last', image_list_old, 'show_image_url_old')"
                               class="el-icon-back icon_btn left_btn"></i>
                            <i v-show="image_list_old.length > 1"
                               @click="changeShowImg('next', image_list_old, 'show_image_url_old')"
                               class="el-icon-right icon_btn right_btn"></i>
                        </div>
                    </el-form-item>
                    <el-form-item label="转化后发票" v-if="show_image_url">
                        <div class="img_box">
                            <el-image class="show_img"
                                      fit="cover"
                                      :src="show_image_url"
                                      :preview-src-list="image_list">
                            </el-image>
                            <i v-show="image_list.length > 1"
                               @click="changeShowImg('last', image_list, 'show_image_url')"
                               class="el-icon-back icon_btn left_btn"></i>
                            <i v-show="image_list.length > 1"
                               @click="changeShowImg('next', image_list, 'show_image_url')"
                               class="el-icon-right icon_btn right_btn"></i>
                        </div>
                    </el-form-item>
                </el-form>

                <div class="btn_box" v-if="!disabled">
                    <div>
                        <el-button @click="lastRow">上一个</el-button>
                        <el-button
                                v-if="!cutSubmitButton"
                                @click="submit_audit('finish')"
                                type="primary"
                        >
                            {{confirmText}}
                        </el-button>
                        <el-popover
                                v-if="cutSubmitButton"
                                placement="top"
                                width="160"
                                style="margin: 0 10px;"
                                v-model="visible">
                            <p>请核对购药支数是否正确填写, 是否继续？</p>
                            <div style="text-align: right; margin: 0">
                                <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                                <el-button type="primary" size="mini" @click="submit_audit('finish')">确定</el-button>
                            </div>
                            <el-button slot="reference" type="primary">{{confirmText}}</el-button>
                        </el-popover>
                        <el-button @click="nextRow">下一个</el-button>
                    </div>
                </div>
            </div>
            <div class="form" v-if="patientForm_transfer">
                <el-form :model="patientForm_transfer"
                         size="small"
                         class="not_bottom_form"
                         label-width="150px">
                    <div class="msg_title">
                        <span>基本信息</span>
                        <span style="font-size: 12px;color: #E6A23C;"
                        >（转化后填报信息）</span>
                    </div>
                    <el-form-item label="患者姓名">
                        <span>{{ patientForm_transfer.patient_name }}</span>
                    </el-form-item>
                    <el-form-item label="性别">
                        <span v-if="patientForm_transfer.sex == 1">男</span>
                        <span v-else>女</span>
                    </el-form-item>
                    <el-form-item label="手机号">
                        <span>{{ patientForm_transfer.phone }}</span>
                    </el-form-item>
                    <el-form-item label="就诊医院">
                        <span>{{ patientForm_transfer.hospital }}</span>
                    </el-form-item>
                    <el-form-item label="就诊城市">
                        <span>{{ patientForm_transfer.province }}/{{ patientForm_transfer.city }}</span>
                    </el-form-item>
                    <el-form-item label="就诊医生">
                        <span>{{ patientForm_transfer.doctor_name }}</span>
                    </el-form-item>
                    <el-form-item label="就诊科室">
                        <span>{{ patientForm_transfer.department }}</span>
                    </el-form-item>
                    <el-form-item label="上报日期">
                        <span>{{ patientForm_transfer.submit_date }}</span>
                    </el-form-item>
                    <el-form-item label="癌种">
                        <span>{{ patientForm_transfer.tumour }}</span>

                    </el-form-item>
                    <el-form-item label="分期（选填）">
                        <span>{{ patientForm_transfer.stage }}</span>
                    </el-form-item>
                    <el-form-item label="治疗线数">
                        <span>{{ patientForm_transfer.line_number }}</span>
                    </el-form-item>
                    <el-form-item label="治疗方案">
                        <span>{{ patientForm_transfer.schedule }}</span>
                    </el-form-item>
                    <div class="msg_title">用药信息</div>
                    <el-form-item label="使用药物">
                        <span>{{ showDrugName(patientForm_transfer.drug_code) }}</span>
                    </el-form-item>
                    <el-form-item label="购药记录">
                    </el-form-item>
                    <div>
                        <el-table :data="patientForm_transfer.medications" stripe>
                            <el-table-column label="周期" prop="medication_cycle_web" width="60"></el-table-column>
                            <el-table-column label="日期" prop="cycle_date" show-overflow-tooltip></el-table-column>
                            <el-table-column label="支数" prop="medication_count" width="60"></el-table-column>
                            <el-table-column label="类别" prop="medication_type"></el-table-column>
                        </el-table>
                    </div>
                    <el-form-item label="是否脱落">
                        <span v-if="patientForm_transfer.is_lose == 1">否</span>
                        <span v-else>是</span>
                    </el-form-item>
                    <el-form-item label="脱落原因" v-if="patientForm_transfer.is_lose == 2">
                        <span>{{ patientForm_transfer.lose_reason1 }}</span>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import {clone, lcGet, formatTime} from "@/global/utils";
    import {getImageUrl} from "@/api/index";
    import imgView from "../common/imgView"
    import {calc_times, calc_times_2} from "@/global/calc_drug"

    const self = this;
    export default {
        name: "auditTwoView",
        components: {
            imgView
        },
        data() {
            return {
                self_: this,
                is_finish: 0,
                confirmText: '完成随访',
                showInfo: false,
                infoText: "在疗程内已有购药记录，无法保存。",
                visible: false,
                cutSubmitButton: false,
                patientForm: null,
                patientForm_transfer: null,
                taskForm: {
                    is_hospital_correct: null,
                    is_medication_count_correct: null,
                },
                activeTaskId: '',
                allTaskData: [], //所有任务列表 old_task_datas + task_data

                rules: {
                    is_hospital_correct: [{ required: true, message: '请选择医院是否正确', trigger: 'blur' }],
                    is_medication_count_correct: [{ required: true, message: '请选择购药支数是否正确', trigger: 'blur' }],
                    // medication_cycle_days: [{ required: true, message: '请选择用药疗程天数', trigger: 'blur' }],

                },
                viewTitle: '',
                disabled: false,

                task_id: null,

                // 锁定参数
                lock_time: 200,
                time_inter: null,
                show_view_loading: false,
                is_lock: false,
                is_requesting: false,

                // 药物配置项
                drug_type_list: [],
                cycle_days: 21,
                cycle_medication_count: 2,
                cycle_type: 'count',

                drug_code_list: [],
                select_drug_conf: {},

                show_image_url_old: null,
                image_list_old: null,
                show_image_url: null,
                image_list: null,
            }
        },
        computed: {
            ...mapState('illuserData', {
                audit_visit_id: 'audit_visit_id',
                audit_ill_ids: 'audit_visit_ids'
            }),
            ...mapState("comInformationData", {
                authority: 'authority',
                allIllData: 'allIllData',
                // drug_code_list: 'drug_code_list',
                medication_type_list: "medication_type_list",
                medication_statusList: "medication_statusList",

                stage_list: 'stage_list',
                line_number_list: 'line_number_list',
                department_list: 'department_list',
                schedule_list: 'schedule_list',
                tumour_list: 'tumour_list',
                tumour_type_list: 'tumour_type_list',
                lose_reason_list: 'lose_reason_list',
                lose_reason_list2: 'lose_reason_list2',
                visit_skeptical: 'visit_skeptical',
            }),
            powerAudit() {
                return this.authority.indexOf('visit-audit-pass') > -1
            },
            powerRefuse() {
                return this.authority.indexOf('visit-audit-refuse') > -1
            },
            powerDel() {
                return this.authority.indexOf('visit-audit-del') > -1
            },

            loading_text() {
                return `还有${this.lock_time}秒将自动解锁！`
            }
        },
        filters: {
            showStatus(val) {
                return val == '1' ? '未完成' :
                    val == '2' ? '已完成' :
                        val == '3' ? '随访中' :
                            ''
            },
            statusTitleFilter(item, self_) {
                let is_finish = item.is_finish;
                if (is_finish == 2) {
                    let medication_status = item.medication_status;
                    let f = self_.medication_statusList.find(l => l.value == medication_status)
                    if (f) {
                        return `(${f.name})`
                    }

                } else if (is_finish == 1) {
                    return '(未完成)'
                }
            },

            filter_task_status(val) {
                return val == '1' ? '未购药' :
                    val == '2' ? '已购药' :
                        val == '3' ? '已脱落' :
                            ''
            }

        },
        mounted() {
            this.task_id = clone(this.audit_visit_id);
            // this.getIllForm(this.task_id);
            this.getDrugList()
        },
        beforeDestroy() {
            window.removeEventListener('mousemove', this.lockNow);
            if (this.time_inter) {
                clearInterval(this.time_inter);
            }

            if (this.is_lock) {
                this.unlockNow()
            }
        },
        methods: {
            getDrugList() {
                this.httpGet('/product/list').then(res => {
                    this.drug_code_list = res.data.data_list;

                    this.getIllForm(this.task_id);
                });
            },
            get_drug_conf() {
                let drug_code = this.patientForm.drug_code;
                let conf = this.drug_code_list.filter(res => res.drug_code === drug_code)[0];
                // console.log(conf, drug_code,this.drug_code_list, '615');
                this.select_drug_conf = conf;

                let names = ['drug_type_list', 'cycle_days', 'cycle_medication_count', 'cycle_type'];
                for (let i = 0; i < names.length; i++) {
                    if (conf && conf[names[i]]) {
                        this[names[i]] = conf[names[i]]
                    }
                }
            },

            showDrugName(val) {
                let text = '';
                this.drug_code_list.forEach(v => {
                    if (val == v.drug_code) {
                        text = v.name
                    }
                });
                return text
            },
            back() {
                this.$emit('changeTopTab', 'tableView')
            },
            copyPhone(val) {
                let phone = this.patientForm.phone;
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(phone);
                    this.$message.success('复制成功')
                }
            },
            mousewheel(e) {
                let v = -e.wheelDelta / 2;
                this.$refs.tabList.scrollLeft += v;
                e.preventDefault();
            },
            activeTab(item) {
                console.log("item", item);
                this.taskForm = this.$options.data().taskForm;
                this.activeTaskId = item.task_id;
                this.viewTitle = `随访工单(${item.source_str})`;

                let is_finish = item.is_finish;
                this.is_finish = is_finish;
                this.confirmText = '完成随访';

                let base_form = {
                    is_hospital_correct: null,
                    is_medication_count_correct: null,
                };
                this.taskForm = item.visit_result || base_form;
                // this.updateTimeStatus();//查询是否在14天内有多个购药记录
                this.taskForm.finish_time = item.finish_time || '';
                if (is_finish == 2) {
                    this.confirmText = '再次保存';
                }
            },

            setKeyUp() {
                // 监听操作
                window.addEventListener('mousemove', this.lockNow);
            },
            setLockInter() {
                this.time_inter = setInterval(() => {
                    this.lock_time--;
                    this.show_view_loading = this.lock_time <= 60 && this.lock_time > 0;
                    if (this.lock_time <= 0) {
                        clearInterval(this.time_inter);
                        this.unlockNow();
                        this.$msgbox({
                            title: '警告',
                            message: '该数据已超时自动解锁，是否要继续随访？',
                            showCancelButton: true,
                            confirmButtonText: '继续随访当前',
                            cancelButtonText: '随访下一个',
                        }).then(() => {
                            this.lockNow()
                        }).catch(() => {
                            this.nextRow('del')
                        })
                    }
                }, 1000)
            },
            changeLockTime() {
                /**
                 * 待审核锁定，10分钟后自动解锁
                 * 操作的情况下5分钟重新锁定，重新计算时间
                 * 不操作，9分钟的时候进行提示，还不操作即锁定
                 */
                this.show_view_loading = false;
                this.lock_time = 590;
            },
            lockNow() {
                if (this.lock_time > 300) return; // 自动锁定时间不到一半的时候再通过
                if (this.is_requesting) return;
                this.is_requesting = true;
                let params = {
                    task_id: this.task_id
                };
                this.httpGet('/visit_task/lock', params).then(res => {
                    this.is_requesting = false;
                    if (res.data.success) {
                        this.is_lock = true;
                        this.changeLockTime();
                        if (this.time_inter) {
                            clearInterval(this.time_inter);
                        }
                        this.setLockInter();
                        console.log('锁定成功');
                    } else {
                        this.$message.warning('该条数据已被其他人锁定！');
                        setTimeout(() => {
                            this.nextRow('del')
                        }, 10)
                    }
                })
            },
            unlockNow() {
                let params = {
                    task_id: this.task_id
                };
                this.httpGet('/visit_task/unlock', params).then(res => {
                    this.is_lock = false;
                    if (this.time_inter) {
                        clearInterval(this.time_inter);
                    }
                    this.lock_time = 200;
                    console.log('解锁成功');
                })
            },
            updateTimeStatus() {
                // 查询是否在14天内有多个购药记录
                let dateRange = 60 * 60 * 24 * 14 * 1000; //14天毫秒数
                let rightData = this.taskForm;
                let medications = this.patientForm.medications;
                this.showInfo = false;
                medications.forEach((item, index) => {
                    if (rightData.medications) {
                        rightData.medications.forEach(rItem => {
                            let r_time = new Date(rItem.cycle_date).getTime();
                            let l_time = new Date(item.cycle_date).getTime();
                            if (Math.abs(r_time - l_time) < dateRange && rItem.medication_count >= 2 && rItem.medication_id !== item.medication_id) {
                                this.showInfo = true;
                            }
                        })
                    }

                })
            },

            getIllForm(id) {
                this.cutSubmitButton = false;
                this.httpGet(`/visit_task/${id}`).then(res => {
                    // console.log("清单....", res.data)
                    this.patientForm = res.data.patient_data;
                    this.patientForm_transfer = res.data.transfer_in_patient || null;

                    // 图片显示
                    this.image_list_old = this.patientForm.invoice_file_urls || [];
                    this.show_image_url_old = this.image_list_old[this.image_list_old.length - 1] || null;
                    if(this.patientForm_transfer) {
                        this.image_list = this.patientForm_transfer.invoice_file_urls || [];
                        this.show_image_url = this.image_list[this.image_list.length - 1] || null;
                    }

                    this.patientForm.phone = this.patientForm.phone == this.patientForm.user_id ? '' : this.patientForm.phone;

                    this.viewTitle = `随访工单(${res.data.task_data.source_str})`;
                    this.confirmText = '完成随访';

                    // taskform 处理
                    let task_data = res.data.task_data;
                    this.taskForm = {
                        is_hospital_correct: task_data.is_hospital_correct || null,
                        is_medication_count_correct: task_data.is_medication_count_correct || null,
                    };

                    this.activeTaskId = res.data.task_data.task_id;
                    this.allTaskData = [res.data.task_data, ...res.data.old_task_datas];
                    this.get_drug_conf()
                })
            },

            changeShowImg(type, list, prop) {
                let index = list.indexOf(this[prop]);
                let length = list.length;
                if(type === 'last') {
                    if(index === 0) {
                        this.$message.warning('已经是第一张了');
                        return
                    }
                    this[prop] = list[index - 1]
                } else {
                    if(index === length - 1) {
                        this.$message.warning('已经是最后一张了');
                        return
                    }
                    this[prop] = list[index + 1]
                }
            },

            lastRow() {
                let index = this.audit_ill_ids.findIndex(n => n == this.task_id);
                if (index > 0) {
                    let id = this.audit_ill_ids[index - 1];
                    this.task_id = clone(id);
                    this.getIllForm(id);
                    this.$message.success('已进入上一条');
                } else {
                    this.$message.warning('已经是第一条了');
                }
            },
            nextRow(type) {
                let index_ = -1;
                this.audit_ill_ids.forEach((v, i) => {
                    if (v == this.task_id) {
                        index_ = i
                    }
                });
                if (index_ === this.audit_ill_ids.length - 1) {
                    this.$message.warning('已经是最后一条了');
                    if (type && type === 'del') {
                        this.goBack()
                    } else {
                        // this.getIllForm(this.task_id)
                    }

                } else {
                    this.unlockNow();
                    setTimeout(() => {
                        let id = this.audit_ill_ids[index_ + 1];
                        this.task_id = clone(id);
                        this.getIllForm(id);
                        this.$message.success('已进入下一条');
                    }, 0);
                }

            },

            submit_audit(type) {
                this.visible = false;

                this.updateTimeStatus();
                if (this.showInfo) {
                    this.$message.warning(this.infoText);
                    return;
                }
                this.$refs.drug_form.validate(valid => {
                    if (valid) {

                        let text = '已完成随访';
                        let params = {
                            ...this.taskForm,
                            patient_id: this.patientForm.patient_id,
                            task_id: this.activeTaskId,
                        };
                        console.log(params, 'audit------');
                        this.httpPost('/visit_task/do_task2', params).then(res => {
                            this.cutSubmitButton = false;
                            this.$message.success(text);
                            setTimeout(() => {
                                this.nextRow()
                            }, 1000)
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        background: #fff;

        .header {
            height: 45px;
            line-height: 45px;

            display: flex;
            justify-content: space-between;
            padding: 0 20px;

            .search {
                padding-top: 15px;
            }
        }

        .main_box {
            display: flex;
            height: calc(100% - 50px);
            overflow: hidden;

            .form {
                flex: 1;
                height: 100%;
                overflow: hidden;
                overflow-y: auto;
                padding: 5px;
                box-sizing: border-box;

                .msg_title {
                    line-height: 35px;
                    font-size: .875rem;
                    padding: 0 20px;
                    background: rgb(233, 233, 235);
                    color: #606266;
                    margin-bottom: 5px;
                }

                .has_btn_title {
                    font-size: 1.25rem;
                    font-weight: 600;
                    display: flex;
                    .phone_verify_result {
                        font-size: 10px;
                        color: red;
                        font-weight: initial;
                    }

                    .btn {
                        padding: 0 20px;
                        margin-left: 20px;
                        color: #409EFF;
                        cursor: pointer;
                        font-size: .9rem;
                        font-weight: 500;
                    }

                    .status_text {
                        font-size: .9rem;
                        font-weight: 500;
                        color: #67C23A;
                        padding: 0 20px;
                    }
                    .tabs {
                        flex: 1;
                        overflow-y: hidden;
                        overflow-x: auto;
                        display: flex;
                        &::-webkit-scrollbar {
                            display: none;
                        }
                        .tab_ {
                            padding: 0 20px;
                            cursor: pointer;
                            white-space: nowrap;
                            span {
                                font-size: 10px;
                                font-weight: 100;
                            }
                        }
                        .active_tab {
                            background: white;
                            border-top: 1px solid #e9e9eb;
                        }
                    }
                }
            }

            .form_right {
                flex: 2;
                display: flex;
                flex-flow: column;

                .el_form_box {
                    flex: 1;
                    overflow-y: auto;

                    .img_box {
                        position: relative;
                        z-index: 1;
                        width: 250px;
                        .show_img {
                            width: 250px;
                            height: 250px;
                        }
                        .icon_btn {
                            position: absolute;
                            line-height: 25px;
                            width: 25px;
                            text-align: center;
                            background-color: rgba(255, 255, 255, .7);
                            z-index: 99;
                            display: none;
                            overflow: hidden;
                            border-radius: 50%;
                            cursor: pointer;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                        .left_btn {
                            left: 5px;
                        }
                        .right_btn {
                            right: 5px;
                        }
                        &:hover {
                            .icon_btn {
                                display: block;
                            }
                        }
                    }
                }

                .drug_log_box {
                    display: flex;

                    .input_span {
                        margin-right: 5px;
                    }

                    .icon_span {
                        padding: 0 10px;
                        font-size: 24px;
                        cursor: pointer;
                    }
                }

                .btn_box {
                    flex: 0 0 40px;
                    width: 100%;
                    text-align: center;
                    padding: 5px;
                    box-sizing: border-box;
                    background-color: #fafafa;
                }

                .finish_form {
                    .form_form_item {
                        position: relative;
                        left: -60px;
                    }
                }
            }
        }

    }
</style>